export const LEVEL_OPTIONS_DEFAULT = [
  { value: '1', label: 'Higher level text and comprehension' },
  { value: '2', label: 'Modified text, visual cues' },
  { value: '3', label: 'Minimal text, visual cues' },
];

export const LEVEL_OPTIONS = LEVEL_OPTIONS_DEFAULT.map((o) => ({
  value: o.value,
  label: `Level ${o.value} - ${o.label}`,
}));

/**
 * Returns the level when it is one of the known instruction levels, otherwise undefined.
 * Used to validate a level coming from a URL.
 */
export const toValidLevel = (level?: string | null) =>
  LEVEL_OPTIONS_DEFAULT.some((o) => o.value === level) ? (level as string) : undefined;
